import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { renderCheckbox, renderField } from '../../../lib/helper/form';
import { connect } from 'react-redux';
import {
  ccsdDefaultChangesListClearFilters,
  ccsdDefaultChangesListSetFilters,
  ccsdDefaultChangesListSetPage,
} from '../../../lib/redux/actions/ccsdDefaultChanges';
import Form from 'react-bootstrap/Form';
import { getFiltersFromSession } from '../../../lib/routing/filters';
import { FEE_ASSURED_CODE_FILTER, applyCodeAndFeeFilters, codeAndFeeInitialValues } from '../../../lib/helper/ccsdChangesFilters';

const nextDay = (dateStr) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + 1);
  return d.toISOString().split('T')[0];
};

const mapStateToProps = (state, ownProps) => {
  const { location } = ownProps;
  const session = getFiltersFromSession(location, 'json') || {};
  return {
    initialValues: {
      ...session,
      createdAt: session['createdAt(after)'] || '',
      validFrom: session['validFrom(after)'] || '',
      ...codeAndFeeInitialValues(session, FEE_ASSURED_CODE_FILTER),
    },
  };
};

const mapDispatchToProps = {
  ccsdDefaultChangesListSetPage,
  ccsdDefaultChangesListSetFilters,
  ccsdDefaultChangesListClearFilters,
};

class CcsdDefaultChangesFilterForm extends React.Component {
  onSubmit(values) {
    const { location } = this.props;
    const submitValues = applyCodeAndFeeFilters(values, FEE_ASSURED_CODE_FILTER);

    if (submitValues.createdAt) {
      submitValues['createdAt(after)'] = submitValues.createdAt;
      submitValues['createdAt(strictly_before)'] = nextDay(submitValues.createdAt);
      delete submitValues.createdAt;
    }

    if (submitValues.validFrom) {
      submitValues['validFrom(after)'] = submitValues.validFrom;
      submitValues['validFrom(strictly_before)'] = nextDay(submitValues.validFrom);
      delete submitValues.validFrom;
    }

    submitValues['exists[checkedAt]'] = submitValues.showChecked ? null : false;

    this.props.ccsdDefaultChangesListSetPage(1);
    this.props.ccsdDefaultChangesListSetFilters(submitValues, location);
  }

  resetFilters() {
    const { reset, ccsdDefaultChangesListClearFilters, onResetPage, location } = this.props;
    if (onResetPage) onResetPage();
    ccsdDefaultChangesListClearFilters(location);
    reset();
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="form-inline form-data-filters">
          <Field name="createdAt" label="Changed on" type="date" component={renderField} />
          <Field name="validFrom" label="Effective from" type="date" component={renderField} />
          <Field name="code" label="Code" type="text" placeholder="e.g. H20" component={renderField} />
          <Field name="feeFrom" label="Fee from" type="number" step="0.01" min="0" placeholder="Any" component={renderField} />
          <Field name="feeTo" label="Fee to" type="number" step="0.01" min="0" placeholder="Any" component={renderField} />
          <Field
            name="showChecked"
            label={<small>Include previously checked changes</small>}
            id="show-checked-default-changes"
            component={renderCheckbox}
          />

          <div className="filter-actions ml-4">
            <button type="submit" className="btn btn-primary btn-sm">
              Filter
            </button>
            <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
              Reset
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'CcsdDefaultChangesFilterForm',
    enableReinitialize: true,
  })(CcsdDefaultChangesFilterForm),
);